(function () {
  const settings = window.freeGiftSettings;
  if (!settings || !settings.enabled) return;

  const DISCOUNT_NAME = settings.discountName.toLowerCase().trim();
  const THRESHOLD_CENTS = settings.thresholdCents;
  const FREE_GIFT_PROPERTY = '_free_gift';

  let popup = null;

  function init() {
    popup = document.getElementById('free-gift-popup');
    if (!popup) return;

    // Remove hidden attribute now that JS is ready
    popup.removeAttribute('hidden');

    popup.querySelector('.free-gift-popup__close')?.addEventListener('click', closePopup);
    popup.querySelector('.free-gift-popup__overlay')?.addEventListener('click', closePopup);

    document.addEventListener('keyup', function (e) {
      if (e.code === 'Escape' && popup.classList.contains('active')) closePopup();
    });

    // Bind variant dropdowns so the add button reflects the selected variant
    popup.querySelectorAll('.free-gift-popup__variant-dropdown').forEach(function (select) {
      select.addEventListener('change', function () {
        var productId = select.dataset.productId;
        var btn = popup.querySelector('.free-gift-popup__add-btn[data-product-id="' + productId + '"]');
        if (btn) {
          btn.dataset.variantId = select.value;
          var selectedOption = select.options[select.selectedIndex];
          btn.disabled = selectedOption.disabled;
          btn.textContent = selectedOption.disabled
            ? (window.variantStrings && window.variantStrings.soldOut) || 'Sold out'
            : (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
        }
      });
    });

    // Bind add-to-cart buttons
    popup.querySelectorAll('.free-gift-popup__add-btn').forEach(function (button) {
      button.addEventListener('click', function () {
        addGiftToCart(button.dataset.variantId, button);
      });
    });

    // Subscribe to cart updates via the theme's pub/sub system
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === FREE_GIFT_PROPERTY) return;
      var cartData = event && event.cartData;
      // The product-form publishes the /cart/add.js response as cartData, which
      // only contains the added line item — not the full cart (no total_price or
      // discount_applications). Always fetch the full cart in that case.
      if (cartData && typeof cartData.total_price !== 'undefined') {
        evaluateCart(cartData);
      } else {
        fetchCartAndEvaluate();
      }
    });
  }

  function fetchCartAndEvaluate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(evaluateCart)
      .catch(function (e) { console.error('[FreeGift] Failed to fetch cart:', e); });
  }

  function evaluateCart(cart) {
    // 1. Check if a free gift is already in the cart
    var hasGift = cart.items && cart.items.some(function (item) {
      return item.properties && item.properties[FREE_GIFT_PROPERTY];
    });

    if (hasGift) {
      closePopup();
      return;
    }

    // 2. Check whether there is a "Free gift" discount applied at cart level
    var discountActive = false;
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      discountActive = cart.cart_level_discount_applications.some(function (d) {
        return d.title && d.title.toLowerCase().trim() === DISCOUNT_NAME;
      });
    }

    // 3. Fall back to threshold check if no discount signal is found
    var meetsThreshold = THRESHOLD_CENTS > 0 && cart.total_price >= THRESHOLD_CENTS;

    if (discountActive || meetsThreshold) {
      openPopup();
    } else {
      closePopup();
    }
  }

  function openPopup() {
    if (!popup || popup.classList.contains('active')) return;
    popup.classList.add('active');
    document.body.classList.add('overflow-hidden');

    // Move focus to the first focusable element inside
    var firstFocusable = popup.querySelector('button, [href], input, select');
    if (firstFocusable) firstFocusable.focus();
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  function addGiftToCart(variantId, button) {
    if (!variantId) return;

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: { [FREE_GIFT_PROPERTY]: 'true' }
        }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          // Error adding to cart
          button.disabled = false;
          button.textContent = originalText;
          return;
        }

        // Success — close the popup immediately
        closePopup();

        // Refresh cart UI (drawer / notification / icon bubble)
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: FREE_GIFT_PROPERTY,
              cartData: cart
            });

            // Also trigger a full cart section re-render if a cart element exists
            var cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (cartElement && typeof cartElement.renderContents === 'function') {
              // Re-fetch with sections to get section HTML for re-render
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [] }) // no-op to get sections
              }).catch(function () {});
            }
          });
      })
      .catch(function (e) {
        console.error('[FreeGift] Failed to add gift to cart:', e);
        button.disabled = false;
        button.textContent = originalText;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
